import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

export interface ValueOption {
  name: string
  id: string
}

export interface Props {
  onSelect: (option: ValueOption) => void
  option: ValueOption
}

const Option = ({ option, onSelect }: Props) => {
  const [hover, setHover] = React.useState<boolean>(false)

  return (
    <Box
      alignItems="center"
      justifyContent="flexStart"
      background={hover ? 'grey200' : 'grey000White'}
      cursor="pointer"
      flexDirection="row"
      gap="s16"
      padding="s16"
      width="full"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={() => onSelect(option)}
      key={option.id}
    >
      <Text.Normal weight="medium" ellipsis>
        {option.name}
      </Text.Normal>
    </Box>
  )
}

export default Option
